import { render, staticRenderFns } from "./BookContent.vue?vue&type=template&id=b62e41e6&"
import script from "./BookContent.vue?vue&type=script&lang=ts&"
export * from "./BookContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports